(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory4sService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory4s: function (parms) {
                return $ihttp.post({
                    method: 2681,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
